<template>
  <div>
    <Card :bordered="false" dis-hover>
      <p slot="title">
        <Icon type="ios-arrow-back" size="20" @click="$router.back(-1)"/>
        <span class="server-title">颜色库</span>
      </p>
     <!-- <a href="#" slot="extra" @click.prevent="addColorType">
        <Icon type="md-add" size="26" title="添加类别" />
      </a>-->
      <div class="overflowRightNav">
        <section class="group_item" v-for="(k,v) in colorGroupType" :key="v" >
          <Row style="padding-bottom: 15px">
            <Col span="8">
              <h4 class="major finger">{{k.category}}<!--<Icon v-if="k.classifyid!=1" @click="editGroupName(k.classifyid,k.category)" type="ios-create-outline" size="22" style="position: relative;top: -3px;" />--></h4>
            </Col>
            <Col span="16" align="right"><!--<Icon v-if="k.classifyid!=1"  @click="delColorType(k.classifyid)" class="finger" type="ios-trash-outline" size="24" color="#5e8bff" />--></Col>
          </Row>
          <Row>
            <span style="padding-bottom: 10px" align="center" v-for="(m,n) in k.colorList" :key="n">
              <Tag type="dot" :color="selectSendIdList.includes(m.id, 0)?'success':''"   v-if="m.cid==0" @click.native="selColorThis(m,n)">{{ m.name }}</Tag>
              <Tag type="dot" :color="selectSendIdList.includes(m.id, 0)?'success':''" v-else @click.native="selColorThis(m,n)"     @on-close="delThatColor(m.id)">{{ m.name }}</Tag>
            </span>
           <!-- <Button icon="ios-add" type="primary" @click="handleAdd(k.classifyid)">添加</Button>-->
          </Row>
        </section>
      </div>
    </Card>
  </div>
</template>
<script>
  export default {
    components: {},
    data() {
      return {
        cid: "",
        colorGroupType:[],
        groupName:'',
        colorName:'',
        selectSendIdList:[],//选择的颜色数组
        sendStateArr:[],

      }
    },
    mounted: function () {
      //DOM更新完后再请求数据
      this.$nextTick(function () {

      });
    },
    created: function () {
      //DOM更新完之前请求数据
      let data= JSON.parse(localStorage.getItem('adminUser'))
      this.cid=data.cid
      this.getColorCategory(this.cid)

    },

    methods: {

      //获取颜色列表
      getColorCategory(cid){
        let data = {
          cid: cid,
        };
        this.$Api.getColorCategory(data).then(res => {
          if(res.code==200){
            this.colorGroupType = res.data
            this.$store.state.AddCommodity.colourGroup.forEach((item,index)=>{
              this.selectSendIdList.push(item.id)
              this.sendStateArr.push(item)
            })
          }else {
            this.$Message.warning(res.msg);

          }
        });
      },

      //添加颜色组
      addColorType(){
        var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
        if(!PermisCode.includes('5')){
          this.$Message.info('暂无权限');
          return
        }
        var _this= this
        this.$Modal.confirm({
          title: '新增颜色组',
          closable: true,
          loading: true,
          render: (h) => {
            return h('Input', {
              props: {
                value: this.value,
                autofocus: true,
                placeholder: '请输入组名'
              },
              on: {
                input: (val) => {
                  _this.groupName = val;
                }
              },
            })
          },
          onOk: () => {
            _this.addColorCategory(_this.cid)
          },
        })
      },
      //添加颜色
      handleAdd (id) {
        var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
        if(!PermisCode.includes('5')){
          this.$Message.info('暂无权限');
          return
        }
        var _this= this
        this.$Modal.confirm({
          title: '新增颜色',
          closable: true,
          loading: true,
          render: (h) => {
            return h('Input', {
              props: {
                value: this.value,
                autofocus: true,
                placeholder: '新增颜色'
              },
              on: {
                input: (val) => {
                  _this.colorName = val;
                }
              },
            })
          },
          onOk: () => {
            _this.addColor(id)
          },
        })
      },
      //添加颜色
      addColor(id){
        var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
        if(!PermisCode.includes('5')){
          this.$Message.info('暂无权限');
          return
        }
        if(this.colorName==''){
          this.$Modal.remove()
          return
        }

        let data = {
          cid: this.cid,
          name: this.colorName,
          classifyid:id
        };
        this.$Api.addColor(data).then(res => {
          if(res.code==200){
            this.$Message.success('添加成功');
            this.$Modal.remove()
            this.getColorCategory(this.cid)
          }else {
            this.$Message.warning(res.msg);
          }
        });
      },
      //添加颜色分组
      addColorCategory(cid){
        var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
        if(!PermisCode.includes('5')){
          this.$Message.info('暂无权限');
          return
        }
        if(this.groupName==''){
          this.$Modal.remove()
          return
        }

        this.$Api.addColorCategory({
          cid: cid,
          name: this.groupName
        }).then(res => {
          if(res.code==200){
            this.$Message.success('添加成功');
            this.$Modal.remove()
            this.getColorCategory(this.cid)
          }else {
            this.$Message.warning(res.msg);
          }
        });
      },
      //修改颜色分组
      editColorCategory(id,name){
        var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
        if(!PermisCode.includes('5')){
          this.$Message.info('暂无权限');
          return
        }
        this.$Api.upColorCategory({
          cid: this.cid,
          name: name,
          id: id
        }).then(res => {
          if(res.code==200){
            this.$Message.success('修改成功');
            this.$Modal.remove()
            this.getColorCategory(this.cid)
          }else {
            this.$Message.warning(res.msg);
          }
        });
      },
      //修改颜色组名字
      editGroupName(id,name){
        var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
        if(!PermisCode.includes('5')){
          this.$Message.info('暂无权限');
          return
        }
        this.colorName = name;
        this.$Modal.confirm({
          title: '修改颜色组名称',
          closable: true,
          loading: true,
          render: (h) => {
            return h('Input', {
              props: {
                value: name,
                autofocus: true,
              },
              on: {
                input: (val) => {

                  this.colorName = val;
                }
              },
            })
          },
          onOk: () => {
            this.editColorCategory(id,this.colorName)
          },

        })
      },
      //删除颜色
      delThatColor (id){
        var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
        if(!PermisCode.includes('5')){
          this.$Message.info('暂无权限');
          return
        }
        var _this = this
        this.$Modal.confirm({
          title: '提示信息',
          content: '您确认删除此颜色吗？',
          loading: true,
          onOk:() =>{
            _this.$Api.delColor({
              id: id
            }).then(res => {
              if(res.code==200){
                this.$Message.success('删除成功');
                this.$Modal.remove()
                this.getColorCategory(this.cid)
              }else {
                this.$Message.warning(res.msg);

              }
            }).catch((err)=>{
              this.$Message.warning(err.msg);
              this.$Modal.remove()
            });

          }
        });
      },

      delColorType(id){
        var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
        if(!PermisCode.includes('5')){
          this.$Message.info('暂无权限');
          return
        }
        this.$Modal.confirm({
          title: '提示信息',
          content: '您确认删除此颜色分组吗？',
          loading: true,
          onOk:() =>{
            this.$Api.delColorCategory({
              id: id
            }).then(res => {
              if(res.code==200){
                this.$Message.success('删除成功');
                this.$Modal.remove()
                this.getColorCategory(this.cid)
              }else {
                this.$Message.warning(res.msg);
              }
            }).catch((err)=>{
              this.$Message.warning(err.msg);
              this.$Modal.remove()
            });;

          }
        });
      },

      //选择颜色
      selColorThis(m,n){
        if(this.selectSendIdList!=''){
           if( this.selectSendIdList.includes(m.id, 0)==false){
             this.selectSendIdList.push(m.id)
             this.sendStateArr.push(m)
           }else {
             this.selectSendIdList.splice(this.selectSendIdList.findIndex(item => item === m.id), 1)
              this.sendStateArr.forEach((item,index) => {
                 if(m.id==item.id){
                   this.sendStateArr.splice(index,1)
                 }
              })
           }
        }else {
          this.selectSendIdList.push(m.id)
          this.sendStateArr.push(m)
        }
        this.$store.commit('modifyColorFn',this.sendStateArr);

      },
    }
  }
</script>


<style lang="scss" scoped>
  .server-title {
    display: inline-block;
    text-align: center;
    width: 88%
  }
  .group_item{
    margin-bottom: 50px;
  }


</style>